export function getLocalData() {
	return JSON.parse(localStorage.getItem(process.env.REACT_APP_VTS_APP_TOKEN)) || {};
}

export default function useAuth() {
	return getLocalData();
}

export function getUserType() {
	return JSON.parse(localStorage.getItem('user_type')) || {};
}
